<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />

    <!-- Breadcrumb y ayuda -->
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <div class="breadcrumb-container">
            <router-link to="/especialidad">Especialidades</router-link>
            > {{ datoEspecialidad.nombre }}
          </div>
        </div>
        <div class="col-1">
          <span
            class="material-symbols-outlined"
            style="font-size: 32px; color: blue; cursor: pointer"
            @click="showModalHelp = true"
          >
            help
          </span>
        </div>
      </div>
    </div>

    <Modal v-model:modelValue="showModalHelp" title="Ayuda">
      <AyudaTramiteForm />
    </Modal>

    <hr />

    <!-- Master -->
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <form>
          <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-1">
                  <label for="idEspecialidad" class="form-label fw-bold"
                    >Id.</label
                  >
                </div>
                <div class="col-1">
                  <input
                    type="text"
                    class="form-control"
                    id="idEspecialidad"
                    name="idEspecialidad"
                    v-model="datoEspecialidad.idEspecialidad"
                    disabled
                  />
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-1">
                  <label for="nombre" class="form-label fw-bold">Nombre</label>
                </div>
                <div class="col-5">
                  <input
                    type="text"
                    class="form-control"
                    id="nombre"
                    name="nombre"
                    v-model="datoEspecialidad.nombre"
                    style="text-transform: uppercase"
                    required
                  />
                </div>
                <div class="col-1">
                  <label for="tipo" class="form-label fw-bold">Tipo</label>
                </div>
                <div class="col-5">
                  <select
                    class="form-control"
                    id="tipo"
                    name="tipo"
                    v-model="datoEspecialidad.tipo"
                    required
                  >
                    <option value="MÉDICO-QUIRÚRGICAS">
                      MÉDICO-QUIRÚRGICAS
                    </option>
                    <option value="PREVENCIÓN, PROMOCIÓN Y SALUD PÚBLICA">
                      PREVENCIÓN, PROMOCIÓN Y SALUD PÚBLICA
                    </option>
                    <option value="QUIRÚRGICAS">QUIRÚRGICAS</option>
                    <option value="CLÍNICAS">CLÍNICAS</option>
                    <option value="LABORATORIO O DIAGNÓSTICAS">
                      LABORATORIO O DIAGNÓSTICAS
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="mb-3">
              <div class="row">
                <div class="col-1">
                  <label for="clasificacion" class="form-label fw-bold"
                    >Clase</label
                  >
                </div>
                <div class="col-5">
                  <select
                    class="form-control"
                    id="clasificacion"
                    name="clasificacion"
                    v-model="datoEspecialidad.clasificacion"
                    required
                  >
                    <option value="M">Medicina</option>
                    <option value="P">Psicología</option>
                    <option value="R">Rehabilitación</option>
                  </select>
                </div>
                <div class="col-1">
                  <label for="titulo" class="form-label fw-bold">Titulo</label>
                </div>
                <div class="col-5">
                  <select
                    class="form-control"
                    id="titulo"
                    name="titulo"
                    v-model="datoEspecialidad.titulo"
                    required
                  >
                    <option disabled value="">Seleccione un título</option>
                    <option
                      v-for="titulo in titulos"
                      :key="titulo"
                      :value="titulo"
                    >
                      {{ titulo }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div class="modal-footer">
          <button
            type="submit"
            class="btn btn-outline-primary"
            @click.prevent="guardarEditEspecialidad"
            v-if="btnEditar"
            title="Actualizar"
          >
            <i class="material-icons" style="font-size: 24px">update</i
            >Actualizar
          </button>
        </div>
      </div>
    </div>

    <!-- Details -->
    <hr />
    <div class="mb-3">
      <table class="tablaBusqueda">
        <tr>
          <td>
            <button
              type="submit"
              class="btn btn-outline-success"
              data-bs-toggle="modal"
              data-bs-target="#ventanaModal"
              @click="abrirModalCrear"
              title="Nuevo registro"
            >
              <i class="material-icons" style="font-size: 24px">add_box</i>Nuevo
              registro
            </button>
          </td>
        </tr>
      </table>
    </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">Prestador de salud</th>
          <th scope="col">Nombre en prestador de salud</th>
          <th scope="col">Nombre en ACFSS</th>
          <th scope="col">Estado</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="espepres in datosPaginados" :key="espepres.idEspePres">
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: orangered; cursor: pointer"
              @click="abrirModalEditar(espepres.idEspePres)"
              title="Editar"
              >edit_square</i
            >
          </td>
          <td>{{ espepres.prestadorRazonSocial }}</td>
          <td>{{ espepres.nombre }}</td>
          <td>{{ espepres.especialidadNombre }}</td>
          <td>{{ espepres.estado }}</td>
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: red; cursor: pointer"
              @click="deleteEspecialidad(espepres.idEspePres)"
              title="Borrar"
              >delete</i
            >
          </td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()">
          <a class="page-link" href="#">Anterior</a>
        </li>
        <li
          id="lugar"
          v-for="pagina in totalPaginas()"
          v-bind:key="pagina"
          v-on:click="getData(pagina)"
          class="page-item"
          v-bind:class="isActive(pagina)"
        >
          <a class="page-link" href="#">{{ pagina }}</a>
        </li>
        <li class="page-item" v-on:click="getNextPage()">
          <a class="page-link" href="#">Siguiente</a>
        </li>
      </ul>
    </nav>
    <!-- Modal -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title" id="exampleModalLabel">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <div class="mb-3">
                <div class="row">
                  <div class="col-12">
                    <label for="especialidadACFSS" class="form-label fw-bold"
                      >Nombre de la especialidad en ACFSS</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="especialidadACFSS"
                      name="especialidadACFSS"
                      v-model="datoEspecialidad.nombre"
                      style="text-transform: uppercase"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <!-- Lista de Valores -->
                <div class="row">
                  <div class="col-12">
                    <label for="idPrestador" class="form-label fw-bold">
                      Prestador de salud</label
                    >
                    <select
                      class="form-control"
                      id="idPrestador"
                      name="idPrestador"
                      v-model="datoEspePres.idPrestador"
                    >
                      <option
                        v-for="prestador in prestadors"
                        :value="prestador.idPrestador"
                        :key="prestador.idPrestador"
                      >
                        {{ prestador.razonSocial }}
                      </option>
                    </select>
                  </div>
                </div>
                <!-- Lista de Valores -->
              </div>
              <div class="mb-3">
                <!-- Lista de Valores -->
                <div class="row">
                  <div class="col-12">
                    <label for="idEspecialidad2" class="form-label fw-bold"
                      >Identificador de la especialidad en el prestador de
                      salud</label
                    >
                    <input
                      type="number"
                      class="form-control"
                      id="idEspecialidad2"
                      name="idEspecialidad2"
                      v-model="datoEspePres.idEspecialidad2"
                      required
                    />
                  </div>
                </div>
                <!-- Lista de Valores -->
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-12">
                    <label for="nombre" class="form-label fw-bold"
                      >Nombre de la especialidad en el prestador de salud</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="nombre"
                      name="nombre"
                      v-model="datoEspePres.nombre"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <button
              type="submit"
              class="btn btn-outline-primary"
              @click.prevent="guardarEspePres"
              v-if="btnCrear_det"
              title="Guardar"
            >
              <i class="material-icons" style="font-size: 32px">save</i>Guardar
            </button>
            <button
              type="submit"
              class="btn btn-outline-primary"
              @click.prevent="guardarEditEspePres"
              v-if="btnEditar_det"
              title="Actualizar"
            >
              <i class="material-icons" style="font-size: 32px">update</i
              >Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Details -->

    <Footer />
  </div>
</template>
<script>
import config from '@/config';
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import api from "@/services/api";
import { validarForm } from "../../modules/validacionesForms.js";
import dateFormat from "@/modules/dateFormat.js";
import { titulos } from "@/data/titulos.js";

import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;
import swal from "sweetalert";
export default {
  components: {
    Layout,
    Footer,
  },
  data() {
    return {
      // Variables master
      especialidads: [],
      datoEspecialidad: {},
      titulo: "",
      btnEditar: false,
      p_idEspecialidad: "",
      // Variables master
      // Variables details
      espepress: [],
      datoEspePres: {},
      nombreBusqueda_det: "",
      titulo_det: "",
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      prestadors: [],
      modalWindow: true,
      // Variables details
      titulos,
    };
  },
  mounted() {
    this.p_idEspecialidad = this.$route.params.p_idespecialidad;
    this.abrirEditar(this.p_idEspecialidad);
    this.getData(this.paginaActual);
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.fetchPrestadors();
    this.fetchEspecialidads();
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    // Procedimientos master
    validarForm() {
      const requiredFields = ["nombre", "tipo", "titulo"];
      const requiredFieldsText = ["nombre", "tipo", "titulo"];
      return validarForm(
        this.datoEspecialidad,
        requiredFields,
        requiredFieldsText
      );
    },
    async guardarEditEspecialidad() {
      if (this.validarForm() === 1) {
        try {
          await api.post("/especialidads",
            this.datoEspecialidad
          );
          swal("Correcto!", "Especialidad creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors);
          array.forEach((element) => swal(String(element)));
        }
      }
    },
    abrirEditar(idEspecialidad) {
      this.modalWindow = true;
      if (idEspecialidad != null) {
        api.get("/vwespecialidads/" + idEspecialidad)
          .then((resp) => {
            this.datoEspecialidad = resp.data;
          });
      }
      this.titulo = "Editar Especialidad";
      this.btnCrear = false;
      this.btnEditar = true;
    },
    cerrarEspecialidad() {
      this.$router.push("/Especialidad");
    },
    // Procedimientos master
    // Procedimientos detalle
    totalPaginas() {
      return Math.ceil(this.espepress.length / this.elementosPorPagina);
    },
    getData(noPagina) {
      api.get("/vwespepress/idespecialidad/" +
            this.p_idEspecialidad
        )
        .then((response) => {
          this.espepress = response.data.reverse();
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini =
            noPagina * this.elementosPorPagina - this.elementosPorPagina;
          let fin = noPagina * this.elementosPorPagina;
          this.datosPaginados = this.espepress.slice(ini, fin);
        });
    },
    getPreviousPage() {
      if (this.paginaActual > 1) {
        this.paginaActual--;
      }
      this.getData(this.paginaActual);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) {
        this.paginaActual++;
      }
      this.getData(this.paginaActual);
    },
    isActive(noPagina) {
      return noPagina == this.paginaActual ? "active" : "";
    },
    validarFormDet() {
      const requiredFields = ["nombre", "tipo", "titulo"];
      const requiredFieldsText = ["nombre", "tipo", "titulo"];
      return validarForm(
        this.datoEspecialidad,
        requiredFields,
        requiredFieldsText
      );
    },
    async guardarEspePres() {
      if (this.validarForm() === 1) {
        try {
          this.datoEspePres.idEspecialidad =
            this.datoEspecialidad.idEspecialidad;
          await api.post("/espepress",
            this.datoEspePres
          );
          $("#ventanaModal").modal("hide");
          swal("Correcto!", "EspePres creada exitosamente!", "success");
          this.getData(this.paginaActual);
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditEspePres() {
      if (this.validarForm() === 1) {
        try {
          await api.post("/espepress",
            this.datoEspePres
          );
          $("#ventanaModal").modal("hide");
          this.getData(this.paginaActual);
          swal("Correcto!", "EspePres creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors);
          array.forEach((element) => swal(String(element)));
        }
      }
    },
    abrirModalCrear() {
      this.modalWindow = true;
      this.datoEspePres = {};
      this.titulo = "Crear Especialidad";
      this.btnCrear_det = true;
      this.btnEditar_det = false;
      this.datoEspePres.idEspecialidad = this.datoEspecialidad.idEspecialidad;
    },
    abrirModalEditar(idEspePres) {
      this.modalWindow = true;
      if (idEspePres != null) {
        api.get("/vwespepress/" + idEspePres)
          .then((resp) => {
            this.datoEspePres = resp.data;
          });
      }
      $("#ventanaModal").modal("show");
      this.titulo = "Editar Especialidad";
      this.btnCrear_det = false;
      this.btnEditar_det = true;
    },
    async deleteEspePres(idEspePres) {
      try {
        await api.delete("/espepress/" + idEspePres
        );
        this.getData(this.paginaActual);
      } catch (error) {
        alert("No se pudo eliminar");
      }
    },
    // Procedimientos detalle
    fetchPrestadors() {
      fetch(config.apiBaseUrl + "/vwprestadors")
        .then((response) => response.json())
        .then((data) => {
          this.prestadors = data;
        })
        .catch((error) => {
          console.error("Error fetching prestadors:", error);
        });
    },
    fetchEspecialidads() {
      fetch(config.apiBaseUrl + "/vwespecialidads")
        .then((response) => response.json())
        .then((data) => {
          this.especialidads = data;
        })
        .catch((error) => {
          console.error("Error fetching especialidads:", error);
        });
    },
  },
};
</script>
